import './ranking.js'
import './highstock.js' 
import Highcharts from 'highcharts'
import HighchartsMoreFn from 'highcharts/highcharts-more'
import HighchartsAccessibilityFn from 'highcharts/modules/accessibility'

HighchartsMoreFn(Highcharts)
HighchartsAccessibilityFn(Highcharts)

// Top spider chart initialization
export function topSpiderChartInit() {

    let categories = []
    let chartTitleList = $('#spider_chart_title_list').val() || '';
    if (chartTitleList != '') {
        categories = chartTitleList.split(',');
    }

    $('.spider_map').each(function(){
        let containerId = $(this).find('div').attr('id');
        drawSpiderWebChart( containerId, categories);
    });

    $('.side_spider_map').each(function(){
        let containerId = $(this).find('div').attr('id');
        drawSpiderWebChart(containerId, categories);
    });
}
// Draw spider chart
// [categories] class is Array.
function drawSpiderWebChart(containerId, categories) {
    let dataValList = $('#' + containerId).data('value-list') || [];
    let data = {
        "chartTitle": "",
        // "categories": ['シャープレシオ', '信託報酬', '販売会社数', '利回り(リターン)', '標準偏差', '注目度'],
        "categories": categories,
        "data": [
            {
                "name": "値",
                "data": dataValList
            }
        ]
    };

    createSpiderWebChart(containerId, data);
}

// Create spider chart
function createSpiderWebChart(containerId, data){
    let seriesData = [];
    let maxNum = 100;

    if(data.data != null) {
        for(let i = 0; i < data.data.length; i++){
            let series = {
                name: data.data[i].name,
                data: data.data[i].data,
                pointPlacement: 'on',
                lineWidth: 1.3,
                marker:{
                    // enabled: false,
                    radius: 1.4,
                }
            }
            if(typeof data.data[i].data !== 'undefined' && data.data[i].data !== null
                && data.data[i].data !== '' && Number(data.data[i].data) > 100) maxNum = Number(data.data[i].data);

            // news/recommend spider chart
            var sortFlag = false;

            $('#' +  containerId).parents('.recommend_main').length > 0? sortFlag = true: sortFlag = false;
            let seriesSecond = {}
            if(sortFlag) {
                series.marker.radius = 4;
                seriesSecond = {
                    marker:{
                        states: {
                            hover: {
                                radius: 5.4
                            },
                            select: {
                                radius: 5.4
                            }
                        }
                    }
                }
                series.marker = Object.assign(series.marker, seriesSecond.marker);
            }

            seriesData.push(series);
        }
    }
    //sidebar spider chart
    let sideVisible = true;
    let sideEnabled = true;
    let hoverEnabled = true;
    let sideSize= '73%';
    let sideDistance = 10;
    let sideMarginLeft = 0;
    if(containerId.indexOf('side_spider_chart_') > -1) {
        sideVisible = false;
        sideEnabled = false;
        hoverEnabled = false;
        sideSize = '100%';
        sideDistance = 0;
        sideMarginLeft = -2.6;
    }

    let chart = Highcharts.chart(containerId, {
        credits: {
            enabled: false
        },
        chart: {
            backgroundColor: 'transparent',
            polar: true,
            type: 'line',
            marginLeft: sideMarginLeft,
        },
        title: {
            text: data.chartTitle
        },
        xAxis: {
            categories: data.categories,
            visible: sideVisible,
            tickmarkPlacement: 'on',
            lineWidth: 0,
            gridLineWidth: 0,
            labels: {
                style: {
                    fontFamily: "-apple-system,\'BlinkMacSystemFont\',\'Hiragino Kaku Gothic ProN\',\'Noto Sans CJK JP\',\'Noto Sans JP\',\'Noto Sans\',sans-serif",
                    fontSize: '11px',
                    fontWeight: 'bold',
                    color: '#64748B'
                },
                distance: sideDistance
            }
        },
        yAxis: {
            gridLineInterpolation: 'polygon',
            // gridLineColor: "#CBD5E1",
            gridLineWidth: 0,
            lineWidth: 0,
            min: 0,
            max: maxNum,
            tickAmount: 3,
            labels: {
                enabled: false
            },
        },
        tooltip: {
            enabled: sideEnabled,
            formatter: function () {
                var tooltip = ''
                tooltip = '<span style="font-size: 10px">' + this.x + '</span><br>' +
                    '<span style="fill:' + this.color + '">● </span><span style="font-weight: bold">' + this.y + 'pt' + '</span></span>'
                return tooltip;
            }
        },
        legend: {
            enabled: false
        },
        pane: {
            size: sideSize
        },
        plotOptions: {
            series: {
                states: {
                    hover: {
                        enabled: hoverEnabled
                    }
                }
            }
        },
        series: seriesData
    });
    let colors = ["#CBD5E1", "#E2E8F0", "#F1F5F9", "#F8FAFC"];
    let parts = 6;
    let interval = 6;

    if(sortFlag) {
        colors = ["#CBD5E1", "#E2E8F0", "#F1F5F9", "#F8FAFC", "#FFFFFF"];
        interval = 14;
    }

    for(let i = 0; i < colors.length; i++) {
        let centerX = chart.plotLeft + chart.yAxis[0].center[0];
        let centerY = chart.plotTop + chart.yAxis[0].center[1];
        let axisLength = chart.yAxis[0].height - interval * i;
        let angleOffset = -Math.PI / 2;
        let angleSegment = Math.PI / (parts / 2);

        for(let j = 0; j < parts; j++) {
            let firstPointX = centerX + (axisLength * Math.cos(angleOffset + (angleSegment * j)));
            let firstPointY = centerY + (axisLength * Math.sin(angleOffset + (angleSegment * j)));

            let secondPointX = centerX + (axisLength * Math.cos(angleOffset + (angleSegment * (j + 1))));
            let secondPointY = centerY + (axisLength * Math.sin(angleOffset + (angleSegment * (j + 1))));

            chart.renderer.path([
                'M', centerX, centerY,
                'L', firstPointX, firstPointY,
                'L', secondPointX, secondPointY,
                'Z'
            ]).attr({
                fill: colors[i],
                'stroke-width': 0,
                'opacity': 1
            }).add();
        }
    }

    return chart;
}

export default topSpiderChartInit;